import { IToast } from '@chakra-ui/core'
import { UploadFile } from '../generated/graphql'

export const APP_NAME = 'Baotree'

export const STRAPI_USER_STORAGE_KEY = 'strapi-user'

export const CLIENT_HOST = process.env.REACT_APP_CLIENT_HOST

export const STRAPI_BASE_URL = process.env.REACT_APP_API_HOST || ''

export const PWA_INSTALLED_KEY = 'pwa-installed'

// Store URLs
export const GOOGLE_PLAY_STORE_URL = process.env.REACT_APP_GOOGLE_PLAY_STORE_URL
export const APP_STORE_URL = process.env.REACT_APP_APP_STORE_URL

// Development
export const IS_PROD = process.env.NODE_ENV === 'production'

export const PASSWORD_REGEX_MESSAGE =
  'Password must contain at least 1 lowercase letter, 1 uppercase letter, 1' +
  ' number and 1 special character'

export const KENYAN_CELLPHONE_REGEX = /^(?:\+254|254)(\d{9})$/
export const SOUTHAFRICAN_CELLPHONE_REGEX =
  /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/im

export const SUCCESS_TOAST: IToast = {
  duration: 6000,
  isClosable: true,
  status: 'success',
  position: 'bottom-right'
}

export const ERROR_TOAST: IToast = {
  duration: 6000,
  title: 'Oops!',
  status: 'error',
  isClosable: true,
  position: 'bottom-right'
}

export const DATE_FORMAT = 'DD/MM/YYYY'

export const PHONE_NUMBER_REGEX = /^\+[1-9]{1}[0-9]{7,11}$/

export const COUNTRY_CODE = '+27'

export const EMPTY_FILE: UploadFile = {
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
  name: '',
  hash: '',
  mime: '',
  size: 0,
  url: '',
  provider: ''
}

export const GOOGLE_MAP_API_KEY = process.env.REACT_APP_GOOGLE_MAP_API_KEY || ''

export const PRIVACY_POLICY_URL = 'https://baotree.io/privacy-policy'

export const IP_API_URL = 'https://ipapi.co/json/'
export const LOCATION_INFO_STORAGE_KEY = 'location-info'
export const BAOTREE_WEBSITE_URL = 'https://baotree.io'
export const BAOTREE_CONTACT_PAGE_URL = `${BAOTREE_WEBSITE_URL}/contact`

export const API_HOST = process.env.REACT_APP_API_HOST || 'http://localhost:1337'
